import {ApiService} from "../api";
import {Projects} from "../../types";
import {AxiosResponse} from "axios";
import {ProjectDTO} from "../../types/DTOs/ProjectDTO";
import {Languages} from "../../types/Models/Languages";
import {LanguageDTO} from "../../types/DTOs/LanguageDTO";
import {Log} from "../../utils/Log";

export class LanguageAPI extends ApiService {
    private constructor() {
        super();
    }

    async getLanguages(): Promise<Languages[]> {
        const response: AxiosResponse<Languages[]> = await this.api.get('/language');
        Log.writeLogDebug(response.data);
        return response.data;
    }

    async createLanguages(data: LanguageDTO): Promise<Languages> {
        const response: AxiosResponse<Languages> = await this.api.post('/language', data);
        return response.data;
    }

    async updateLanguages(id: string, data: Partial<LanguageDTO>): Promise<Languages> {
        const response: AxiosResponse<Languages> = await this.api.put(`/language/${id}`, data);
        return response.data;
    }

    async deleteLanguages(id: string): Promise<void> {
        await this.api.delete(`/language/${id}`);
    }
}